import { all, put, takeLatest } from 'redux-saga/effects';
import { requestApi2 } from '../../../../lib/request';
import { setLineMemoryMyUuid } from '../../../common/schemes/line/actions';
import * as action from '../actions';
import { constants, services } from '../config';

export function* initMemorySaga({ lineId }) {
  try {
    const response = yield requestApi2(services.initMemory(lineId));
    if (response && response.status >= 200 && response.status < 300) {
      const memory = response.data?.data ?? response.data;
      yield put(action.initMemorySuccess(memory));
      if (memory?.uuid) {
        yield put(setLineMemoryMyUuid(memory.uuid));
      }
    } else {
      throw response;
    }
  } catch (error) {
    yield put(action.initMemoryFail(error));
  }
}

export function* getMemorySaga({ lineId, memoryUuid }) {
  try {
    if (!memoryUuid) {
      yield put(action.getMemorySuccess(null, lineId));
      return;
    }
    const response = yield requestApi2(services.getMemory(lineId, memoryUuid));
    if (response && response.status >= 200 && response.status < 300) {
      const memory = response.data?.data ?? response.data;
      yield put(action.getMemorySuccess(memory, lineId));
      if (memory?.uuid) {
        yield put(setLineMemoryMyUuid(memory.uuid));
      }
    } else if (response?.status === 404) {
      yield put(action.getMemorySuccess(null, lineId));
    } else {
      throw response;
    }
  } catch (error) {
    yield put(action.getMemoryFail(error));
  }
}

export function* saveBlockSaga({ lineId, blockKey, answers, memoryUuid }) {
  try {
    const response = yield requestApi2(services.saveBlock(lineId, blockKey, answers, memoryUuid));
    if (response && response.status >= 200 && response.status < 300) {
      yield put(action.saveBlockSuccess(response.data?.data ?? response.data));
    } else {
      throw response;
    }
  } catch (error) {
    yield put(action.saveBlockFail(error));
  }
}

export function* generateMemorySaga({ lineId, memoryUuid }) {
  try {
    const response = yield requestApi2(services.generateMemory(lineId, memoryUuid));
    if (response && response.status >= 200 && response.status < 300) {
      yield put(action.generateMemorySuccess(response.data?.data ?? response.data));
    } else {
      throw response;
    }
  } catch (error) {
    yield put(action.generateMemoryFail(error));
  }
}

export function* pollStatusSaga({ lineId, memoryUuid }) {
  try {
    const response = yield requestApi2(services.pollStatus(lineId, memoryUuid));
    if (response && response.status >= 200 && response.status < 300) {
      yield put(action.pollStatusSuccess(response.data?.data ?? response.data));
    } else {
      throw response;
    }
  } catch (error) {
    yield put(action.pollStatusFail(error));
  }
}

function* actionWatcher() {
  yield takeLatest(constants.INIT_MEMORY, initMemorySaga);
  yield takeLatest(constants.GET_MEMORY, getMemorySaga);
  yield takeLatest(constants.SAVE_BLOCK, saveBlockSaga);
  yield takeLatest(constants.GENERATE_MEMORY, generateMemorySaga);
  yield takeLatest(constants.POLL_STATUS, pollStatusSaga);
}

export default function* rootSaga() {
  yield all([actionWatcher()]);
}
